import {makeAutoObservable} from 'mobx'
export default class BrickStore{
    constructor() {
        this._bricks = [] || null
        makeAutoObservable(this)
    }
    setBricks(bricks){
        this._bricks = bricks
    }
    getBricks(){
        return this._bricks
    }
}